import { makeVar } from '@apollo/client'

export const submitValidationCriteriaIsValidVar = makeVar<boolean | null>(null)
export const hasPreviousSubmissionsVar = makeVar<boolean>(false)
export const submissionDetailsVar = makeVar<any>({})

export const setSubmissionDetails = (submissionDetails: object) => {
  return submissionDetailsVar(submissionDetails)
}

export const setHasPreviousSubmissions = (flag: boolean) => {
  return hasPreviousSubmissionsVar(flag)
}

export const setSubmitValidationCriteriaIsValid = (flag: boolean) => {
  return submitValidationCriteriaIsValidVar(flag)
}
